import { PropsWithChildren, useState } from "react";

import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";

interface IExportDropDownProperties extends PropsWithChildren {
  canExport?: boolean;
  label: string;
  tooltip: string;
}

export default function ExportDropDown({ canExport = false, children, label, tooltip }: IExportDropDownProperties) {
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorElement);

  const handleClick = (currentTarget: EventTarget & HTMLButtonElement) => {
    setAnchorElement(currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  return (
    <div>
      <Tooltip placement="bottom" title={tooltip}>
        <span>
          {/* required wrapper for placing tooltip on isDisabled button */}
          <Button
            className="company-export"
            color="secondary"
            disabled={!canExport}
            endIcon={<KeyboardArrowDownRoundedIcon />}
            onClick={(e) => handleClick(e.currentTarget)}
            sx={{ borderRadius: "8px" }}
            variant="contained"
          >
            {label}
          </Button>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorElement}
        id="basic-menu"
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        onClick={handleClose}
        onClose={handleClose}
        open={isOpen}
      >
        {children}
      </Menu>
    </div>
  );
}
